import { useCallback, useEffect, useState } from 'react';

export type ViewMode = 'grid' | 'feed';

export const VIEW_MODE_STORAGE_KEY = 'hp-view-mode';

function readStoredMode(): ViewMode {
  try {
    const v = sessionStorage.getItem(VIEW_MODE_STORAGE_KEY);
    if (v === 'feed' || v === 'grid') return v;
  } catch {
    // SSR or sessionStorage unavailable
  }
  return 'grid';
}

let currentMode: ViewMode = readStoredMode();
const listeners = new Set<() => void>();

export function useViewMode(): [ViewMode, (mode: ViewMode) => void] {
  const [viewMode, setViewModeState] = useState<ViewMode>(currentMode);

  useEffect(() => {
    const listener = () => setViewModeState(currentMode);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const setViewMode = useCallback((mode: ViewMode) => {
    currentMode = mode;
    try {
      sessionStorage.setItem(VIEW_MODE_STORAGE_KEY, mode);
    } catch {
      // SSR or sessionStorage unavailable
    }
    listeners.forEach((l) => l());
  }, []);

  return [viewMode, setViewMode];
}
